import { mapState } from 'vuex'
import get from 'lodash/get'
import moment from 'moment'
import { isRole } from '../utils/users'
import { userPrimaryRoles, licenses, teamStatusStyles, complementaryLicenseStatusCodes } from '../utils/constants'

export default {
  computed: {
    ...mapState({
      userInfo: state => get(state.userInfo, 'userInfo') || {},
      educationalLevels: state => state.profile.educationalLevels,
      schoolGroupVO: state => state.profile.userProfile.schoolGroupVO
    }),
    currentUserRoles() {
      return get(this.userInfo, 'primaryRoles')
    },
    isAdmin() {
      return !!(this.currentUserRoles && isRole(this.currentUserRoles, userPrimaryRoles.admin))
    },
    isManager() {
      return !!(this.currentUserRoles && isRole(this.currentUserRoles, userPrimaryRoles.manager))
    },
    isTeacher() {
      return !!(this.currentUserRoles && isRole(this.currentUserRoles, userPrimaryRoles.teacher))
    },
    isTrial() {
      return !!(this.currentUserRoles && isRole(this.currentUserRoles, userPrimaryRoles.trial))
    },
    isFreemium() {
      return this.isTeacher
        ? Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.freemium && this.userInfo.educationalLevels.includes(bl.level)))
        : Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.freemium))
    },
    isProgramFee() {
      return this.isTeacher
        ? Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.programFee && this.userInfo.educationalLevels.includes(bl.level)))
        : Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.programFee))
    },
    isCampus() {
      return this.isTeacher
        ? Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.campus && this.userInfo.educationalLevels.includes(bl.level)))
        : Boolean(this.userInfo.baseLicenses.find(bl => bl.code === licenses.campus))
    },
    isCustom() {
      return Boolean(this.userInfo.baseLicenses.every(bl => bl.code === licenses.custom))
    },
    isMainTrial() {
      return this.userInfo.mainTrial
    },
    showAddTeachersElement() {
      return this.isAdmin || this.isManager
    },
    remainingDays() {
      const joinedDate = moment(this.userInfo.joinDate)
      const diffDate = 15 - moment().diff(joinedDate, 'days')
      return diffDate > 0 ? diffDate : 0
    },
    userEducationalLevels() {
      if (this.isAdmin) return this.schoolGroupVO.educationalLevels
      else if (this.isTeacher) return this.userInfo.educationalLevels
      else return this.schoolGroupVO.currentSchool.impartedLevels
    },
    hasWhiteLabel() {
      return this.userInfo.activeWhitelabelLicense && this.userInfo.activeWhitelabelLicense.status === complementaryLicenseStatusCodes.active
    }
  },
  methods: {
    getLevel(level) {
      return this.educationalLevels.find(edLevel => edLevel.id === level).name.toLowerCase()
    },
    getStatusStyles(status) {
      return teamStatusStyles.find(statusStyle => statusStyle.value === status.toLowerCase()).class
    },
    getStatusIcon(status) {
      return teamStatusStyles.find(statusStyle => statusStyle.value === status.toLowerCase()).icon
    }
  }
}
